<template>
    <div class="cruiseSpecialists" v-if="randomResult" style="">
        <img
            alt="Cruise Specialist"
            class="personeelsfoto_index"
            :src="randomResult.img"
        />

        <div align="center">
            <img
                src="https://cdn.cruisereizen.nl/img/marketing/personeel/pijltje_small.png"
            />
            <span class="white">
                <h3>
                    {{ randomResult.name }}<br />
                    <small>Cruise Specialist</small>
                </h3>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CruiseSpecialist',
    computed: {
        randomResult: function() {
            if (this.cruiseSpecialists && this.cruiseSpecialists.collection) {
                let collection = this.cruiseSpecialists.collection
                return collection[Math.floor(Math.random() * collection.length)]
            }
            return null
        },
        cruiseSpecialists: function() {
            return this.$store.state.cruiseSpecialists
        },
    },
}
</script>

<style scoped>
.cruiseSpecialists {
    position: relative;
}

.cruiseSpecialists > img {
    display: block;
}

.cruiseSpecialists > div {
    position: absolute;
    top: 40px;
    left: 140px;
    width: 100%;
    font-family: verdana, calibri;
}

.cruiseSpecialists > div > img {
    position: absolute;
    top: 40px;
    display: block;
}

.cruiseSpecialists > div > span {
    position: absolute;
    left: 20px;
}
</style>
